import StyledToolTip from './StyledToolTip';
import { withStyles } from '@material-ui/core';

const style = () => ({
  tooltip: {
    maxHeight: 500,
    whiteSpace: "pre-wrap",
    overflowY: 'auto',
  }
});

const StyledToolTipWithScroll = (props) => <StyledToolTip interactive={true} {...props} />;

export default withStyles(style)(StyledToolTipWithScroll);
